
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["bullet",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('circle',{attrs:{"id":"id-94a","cx":"13","cy":"13","r":"13"}})]),_c('use',{attrs:{"stroke":"#FFF","stroke-width":"1.17","xlink:href":"#id-94a","stroke-linecap":"square","transform":"translate(7 7)","fill":"none","fill-rule":"evenodd"}})])
          )
        }
      }
    